<template>
  <div class="rj-content">
    <v-overlay :value="loader" z-index="7">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <h1 class="new-consult">Mis consultas</h1>
    <p class="main-description">
      Agenda una consulta conmigo y analizaremos tu carta astral durante una sesión
      presencial o virtual, en la que te ayudaré a definir las acciones futuras adecuadas
      para alcanzar el éxito.
    </p>

    <v-row>
      <v-col sm="">
        <v-card v-if="form">
          <v-form v-model="valid" ref="form" :lazy-validation="lazy" class="ma-2">
            <v-row>
              <v-col class="" sm="8">
                <label for="">Fecha y hora de la consulta</label>
                <br />
                <v-row class="">
                  <v-col md="6">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="date"
                          label=""
                          prepend-icon=""
                          append-icon="mdi-calendar"
                          v-on:click:append="menu = true"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="date"
                        :allowed-dates="allowedDates"
                        :min="min"
                        no-title
                        scrollable
                        @change="$refs.menu.save(date)"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="6">
                    <v-select
                      v-model="hour"
                      :items="allowedHours"
                      append-icon="mdi-clock"
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <span
                  style="
                    font-size: 14px;
                    color: rgb(140 140 140);
                    margin-top: -25px;
                    display: block;
                  "
                  >La fecha y la hora están sujetas a cambios. América Lima/Bogota -
                  UTC-5</span
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col class="" sm="8">
                <label for="">Motivo de consulta</label>
                <br />
                <v-select
                  v-model="value"
                  :items="items"
                  :rules="[(v) => !!v || 'Seleccione un motivo']"
                  placeholder="Selecciona el motivo"
                  @change="otherInput"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="otherSelect">
              <v-col sm="6">
                <p id="paragraph" v-if="value == 'Consulta para hijos'">
                  Escribe los datos de tu hija(o): Nombre, Fecha, hora y lugar de
                  nacimiento / Solicita una consulta por cada hija(o)
                </p>
                <v-textarea
                  outlined
                  name="input-7-4"
                  label="Cuéntame el motivo de su consulta"
                  placeholder="Datos de tu hijo(a)"
                  v-model="reason"
                  :rules="nameRules"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="12">
                <v-btn
                  class="primary"
                  large
                  :disabled="!valid || !hour || !date"
                  @click="validate()"
                >
                  Solicitar consulta
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="!form">
      <v-col>
        <v-card>
          <div class="title-box">Datos de su consulta</div>
          <div class="details">
            <dd>Fecha: {{ picker }}</dd>
            <dd>Motivo: {{ value }}</dd>
            <dd v-if="value === 'Consulta para hijos'">Detalle: {{ reason }}</dd>
          </div>
          <div class="ctn-btns">
            <v-btn outlined color="primary" class="" :to="{ name: 'Appoinments' }"
              >Cancelar</v-btn
            >
            <v-btn class="ml-3" color="primary" @click="sendCon"
              >Solicitar consulta</v-btn
            >
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialog" max-width="512" class="" persistent>
        <v-card rounded class="dialog-appointment pa-3">
          <v-icon @click="toAppoiments" style="position: absolute" class="close-btn"
            >mdi-close</v-icon
          >
          <div class="ctn-img text-center mt-8">
            <img src="../assets/logo.png" />
          </div>
          <v-card-text>
            <p class="text-center modal-text">
              Hemos recibido tu solicitud. <br />
              Pronto te enviaremos un correo confirmando el <strong>día</strong>, la
              <strong>hora</strong> y el <strong>costo</strong> de la consulta. <br />
              Recuerda actualizar todos los datos en
              <router-link :to="{ name: 'Profile' }">tu perfil</router-link>.
            </p>
            <v-btn color="primary" class="btn-continue" @click="toAppoiments"
              >Continuar</v-btn
            >
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import router from "@/router";

import $day from "dayjs";
var utc = require("dayjs/plugin/utc");
$day.extend(utc);
export default {
  name: "NewConsult",
  data() {
    return {
      min: $day().format("YYYY-MM-DD"),
      items: ["Consulta personal", "Consulta de Negocios", "Consulta para hijos"],
      date: "",
      hour: "",
      value: null,
      otherSelect: false,
      allowedHours: ["10:00", "12:00", "16:00", "18:00"],
      valid: false,
      lazy: false,
      reason: "",
      nameRules: [(v) => !!v || "Motivo es requerido"],
      form: true,
      dialog: false,
      ddmmyy: "",
      loader: false,
      menu: false,
    };
  },
  computed: {
    picker() {
      return $day(this.date + "" + this.hour).format("YYYY-MM-DD H:mm:ss");
    },
    ...mapState("user", ["info"]),
  },
  methods: {
    ...mapActions("user", ["fetchInfo"]),
    allowedDates(val) {
      return $day(val).day() !== 0;
    },
    otherInput() {
      if (this.value === "Consulta para hijos") {
        this.otherSelect = true;
      } else {
        this.otherSelect = false;
      }
    },
    validate() {
      this.$refs.form.validate();
      this.form = false;
    },
    async sendCon() {
      this.loader = true;
      let reasonDetails = "";
      if (this.reason === "") {
        reasonDetails = this.value;
      } else {
        reasonDetails = `${this.value} - ${this.reason}`;
      }
      let dataSend = {
        reason: reasonDetails,
        date: this.picker, // dayjs
      };
      /*this.loader = true*/
      console.log(this.info);
      const dataPostContact = {
        Data: {
          Email: this.info.user.email,
          FirstName: this.info.user_data.names,
          LastName: this.info.user_data.surnames,
          EmailPerm: "1",
        },
      };
      axios.post(
        `https://clientapi.benchmarkemail.com/Contact/16603151/ContactDetails`,
        dataPostContact,
        {
          headers: {
            "Content-Type": "application/json",
            AuthToken: "8A6D78E4-CB1B-4185-A003-CD38D170CE87",
          },
        }
      );
      axios.post(
        `https://clientapi.benchmarkemail.com/Contact/16660543/ContactDetails`,
        dataPostContact,
        {
          headers: {
            "Content-Type": "application/json",
            AuthToken: "8A6D78E4-CB1B-4185-A003-CD38D170CE87",
          },
        }
      );
      try {
        await axios.post("personal-consultation", dataSend);
        /*await router.push({name: 'Appoinments'});*/
        this.loader = false;
        this.dialog = true;
      } catch (error) {
        console.log(error);
        this.loader = false;
      }
    },
    toAppoiments() {
      router.push({ name: "Appoinments" });
    },
  },
  mounted() {
    this.fetchInfo();
  },
};
</script>
<style lang="scss" scoped>
$breakpoints: (
  "tablet": 768px,
);
@mixin mobile {
  @media screen and (max-width: map-get($breakpoints, tablet)) {
    @content;
  }
}
.ctn-btns {
  margin-top: 30px;
  margin-bottom: 10px;
  text-align: center;
  @include mobile {
    margin-top: 45px;
    .v-btn.ml-3 {
      margin-left: 0 !important;
      margin-top: 8px;
    }
  }
}
.new-consult {
  font-family: "Virgula Vulgaris" !important;
  font-weight: 200;
  font-size: 32px !important;
  color: #656565 !important;
}
::v-deep .v-btn,
:not(.v-picker .v-btn) {
  text-transform: unset;
  font-family: "Avenir";
  letter-spacing: normal;
  font-size: 14px;
  margin-top: 5px;
  border-radius: 7px;
  margin-right: 20px;
}
.v-card {
  padding: 30px;
}
.title-box {
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 22px;
  color: #656565;
}
.details {
  color: #656565;
}
dd {
  line-height: 22px;
  font-size: 16px;
  font-weight: 200;
  margin-bottom: 12px;
}
::v-deep .v-input {
  width: 250px;
  .v-messages__message {
    padding-top: 3px;
  }
  &.v-input--is-disabled {
    .v-input__slot::before {
      display: none;
    }
    .v-input__append-inner {
      display: none;
    }
  }
  .v-input__slot {
    margin-bottom: 0;
    .v-text-field__slot input {
      color: #656565;
    }
  }
}
.dialog-appointment {
  ::v-deep .btn-continue {
    display: block;
    margin: 30px auto 10px;
  }
}
.modal-text strong {
  color: var(--v-anchor-base);
}
::v-deep .v-date-picker-table {
  height: 215px;
}
::v-deep .v-picker {
  padding-top: 12px;
  @include mobile {
    padding: 0 !important;
  }
}
.bussiness-details {
  font-size: 12px;
  color: #656565;
  font-weight: 200;
}
#paragraph {
  margin-top: -45px;
  color: #8c8c8c;
  line-height: 20px;
  margin-bottom: 25px;
}
</style>
